import classnames from 'classnames'
import type {FC} from 'react'
import type React from 'react'

import styles from './grid.module.css'

interface GridProps extends React.HTMLAttributes<HTMLDivElement> {
    margin?: 10 | 20 | 40
    center?: boolean
    evenly?: boolean
    alignItemStart?: boolean
    middle?: boolean
    fullHeight?: boolean
    mobileDisable?: boolean
    className?: string
    wrap?: boolean
}

/**
 * @deprecated Use '@pleo-io/telescope' Stack or Inline
 */
export const Grid: FC<GridProps> = (props) => {
    const {
        children,
        margin,
        center,
        evenly,
        alignItemStart,
        middle,
        fullHeight,
        mobileDisable,
        className = '',
        wrap,
        ...restProps
    } = props
    const classes = classnames(styles.grid, {
        [styles['margin' + margin]]: margin,
        [styles.center]: center,
        [styles.middle]: middle,
        [styles.evenly]: evenly,
        [styles.alignItemStart]: alignItemStart,
        [styles.fullHeight]: fullHeight,
        [styles.mobileDisable]: mobileDisable,
        [styles.wrap]: wrap,
        [className]: className,
    })
    return (
        <div className={classes} data-generic-ui="grid" {...restProps}>
            {children}
        </div>
    )
}

interface GridItemProps extends React.HTMLAttributes<HTMLDivElement> {
    className?: string
    width?: number | string
    maxWidth?: number | string
    style?: any
    left?: boolean
    right?: boolean
    auto?: boolean
    center?: boolean
    fullHeight?: boolean
    borderRight?: boolean
}

/**
 * @deprecated Use '@pleo-io/telescope' Stack or Inline
 */
export const GridItem = (props: GridItemProps) => {
    const {
        children,
        className = '',
        width,
        maxWidth,
        style,
        left,
        right,
        auto,
        center,
        fullHeight,
        borderRight,
        ...restProps
    } = props
    const finalStyle = style || {}
    if (maxWidth) {
        finalStyle.maxWidth = maxWidth
    }
    if (width) {
        finalStyle.maxWidth = width
        finalStyle.minWidth = width
    }
    const classes = classnames(styles.item, {
        [className]: className,
        [styles.left]: left,
        [styles.right]: right,
        [styles.fullHeight]: fullHeight,
        [styles.center]: center,
        [styles.flexAuto]: auto,
        [styles.borderRight]: borderRight,
    })
    return (
        <div className={classes} style={finalStyle} {...restProps}>
            {children}
        </div>
    )
}
